import { Component, OnInit } from '@angular/core';
import { AlertsServiceService } from '../../services/alerts-service.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-dialog-notification-dy',
  templateUrl: './dialog-notification-dy.component.html',
  styleUrls: ['./dialog-notification-dy.component.scss']
})
export class DialogNotificationDyComponent implements OnInit {
  notificationDetailMsg: any = null;

  
  constructor( private alertService:AlertsServiceService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig) {
      this.notificationDetailMsg = config.data;
     }

  ngOnInit(): void {
  }
  acknowledge(alertNotificationId) {
    const notification = {
      alertNotificationId: alertNotificationId,
      acknowledged: true,
      acknowledgedBy: localStorage.getItem('appEmail'),
    }
    this.alertService.acknowledgeAlert(notification).subscribe((data) => { });
    this.ref.close();
  }
}
